<template>
  <div>
    <v-card-text>
      <v-row cols='12'>
        <v-col cols='12' md='6'>
          <v-card outlined min-height="100%">
            <summary-info :event_info="event_info"></summary-info>
          </v-card>
        </v-col>
        <v-col cols='12' md='6'>
          <v-card outlined min-height="100%">
            <summary-contractor :event_info="event_info" v-if="event_info.client.client_is"></summary-contractor>
          </v-card>
        </v-col>
      </v-row>
      <v-row cols='12'>
        <v-col cols='12' md='6'>
          <v-card outlined min-height="100%">
            <summary-operation :event_info="event_info"></summary-operation>
          </v-card>
        </v-col>
        <v-col cols='12' md='6'>
          <v-card outlined min-height="100%">
            <summary-financial :event_info="event_info"></summary-financial>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'EventSummary',
    components: {
      SummaryInfo: () => import ('../summary/SummaryInfo.vue'),
      SummaryContractor: () => import ('../summary/SummaryContractor.vue'),
      SummaryOperation: () => import ('../summary/SummaryOperation.vue'),
      SummaryFinancial: () => import ('../summary/SummaryFinancial.vue'),
    },
    computed: {
      ...mapState({
        stepper: state => state.Event.stepper,
        event_info: state => state.Event.event_info
      }),
    },

  }
</script>

<style lang="scss" scoped>

</style>